import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { ValidationError } from '@/lib/graphql/generated/graphql';
import { translateValidationError } from '@/lib/utils/validation-error-translator';
import { ExtendedValidationError } from '@/types/validation-error';

/**
 * Hook to translate validation errors based on current language
 * @returns A function that translates a ValidationError
 */
export function useTranslateValidationError() {
  const { t, i18n } = useTranslation();

  return useCallback(
    (error: ValidationError): ExtendedValidationError => {
      return translateValidationError(error, t, i18n.language);
    },
    [t, i18n.language]
  );
}
